Auth = require 'app/scripts/db/auth'
AddTagView = require 'app/scripts/views/organization/add-tag-view'
EditTagView = require 'app/scripts/views/organization/edit-tag-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
Controller = require 'app/scripts/controller'
{ track } = require '@trello/analytics'
{ TextfieldClasses } = require '@trello/nachos'
_ = require 'underscore'
$ = require 'jquery'

t = require('app/scripts/views/internal/teacup-with-helpers')('board_collections')

collectionsListHelper = t.renderable (tags, showCheck) ->
  if tags
    t.ul '.select-tags-list', ->
      for tag in tags
        t.li '.select-tags-list-item.js-tag-item',
          'data-id-tag': tag.id
        , ->
          t.a '.select-tags-list-item-name-link.js-toggle-tag', ->
            if showCheck
              t.icon 'check', class: 'select-tags-list-item-name-link-check-icon'
            t.text tag.get('name')

collectionsList = t.renderable (filteredTags) ->
  collectionsListHelper(filteredTags.associated, true)
  collectionsListHelper(filteredTags.notAssociated, false)

template = t.renderable ({ board, collectionsEnabled, billingUrl, orgUrl, hasTags, hideExplainer }) ->
  if !collectionsEnabled
    t.div '.collections-upsell.ads-layouts-experiment', ->
      t.div '.collections-upsell-body', ->
        t.h4 '.collections-upsell-header', ->
          t.format 'ads-title'
        t.p ->
          t.format 'collections-let-you-group-and-filter'
        t.a '.js-learn-more', { href: '/business-class', target: '_blank' }, ->
          t.format 'ads-learn-more'
        t.div '.collections-upgrade-action', ->
          if billingUrl
            t.a '.button.primary.js-upgrade', { href: billingUrl }, ->
              t.format 'ads-upgrade'
          else
            t.a '.button.primary.js-add-team', href: '#' , ->
              t.format 'ads-upgrade'
    return
  else
    if !hideExplainer
      t.div '.collections-info', ->
        t.span '.collections-explainer-close.js-close-explainer', ->
          t.icon 'close'
        t.img '.collections-image', { src: require('resources/images/collections/business-class-feature-roadmap.png') }
        t.p ->
          t.format 'collections-let-you-group-and-filter'
        t.p '.js-learn-more', ->
          t.format 'learn-more-about-collections'
    t.div '.collections-select-lists', ->
      if hasTags
        t.div '.has-collections', ->
          t.p '.js-team-page', ->
            t.format 'visit-team-page-create-some',
              orgUrl: orgUrl
          t.a '.quiet-button.full.create-collection-btn.js-add-tag', { href: '#' }, ->
            t.format "create-collection"
        t.input ".js-collections-search #{TextfieldClasses.STATIC}", { type: 'text', placeholder: t.l("search-collections"), autocomplete: 'off' }
        t.div '.js-filtered-collections'
      else
        t.div '.no-collections', ->
          t.p ->
            t.format 'no-collections'
          t.p '.js-team-page', ->
            t.format 'visit-team-page-create-some',
              orgUrl: orgUrl
          t.a '.quiet-button.full.create-collection-btn.js-add-tag', { href: '#' }, ->
            t.format "create-collection"

getIdTag = (e) ->
  $(e.target).closest('.js-tag-item')[0].getAttribute('data-id-tag')

module.exports = class BoardCollectionsView extends View
  className: 'board-menu-collections-select'

  noPadding: true

  initialize: ->
    @sidebarView = @options.sidebarView
    @organization = @options?.org || @model.getOrganization()
    @collectionsEnabled = @organization? && @organization.isFeatureEnabled('tags')

    @listenTo @model, 'change:idOrganization', @refereshOrganization
    @listenTo @model, 'change:idTags', @render
    @listenTo Auth.me(), 'change:oneTimeMessagesDismissed', @render

    if @collectionsEnabled
      @listenTo @organization.tagList, 'add remove reset change', @render

    super

  events:
    'click .js-add-tag': 'addTag'
    'keyup .js-collections-search': 'renderFilteredCollections'
    'click .js-toggle-tag': (e) ->
      track("Board Menu", "Collections Menu", "Toggle Collections")
      @toggleTag getIdTag(e)
    'click .js-add-team': (e) ->
      Util.stop(e)
      @model.trigger 'add-to-team'
      track("Board Menu", "Collections Menu", "Lets Add To Team")
    "click .js-close-explainer": (e) ->
      Auth.me().dismiss("CollectionsExplainer")
      track('Board Menu', 'Collections Menu', 'Dismiss Collections Explainer')
    'click .js-learn-more a': (e) ->
      track('Board Menu', 'Collections Menu', 'Clicks Learn More Link')
    'click .js-team-page a': (e) ->
      track('Board Menu', 'Collections Menu', 'Clicks Team Page Link')
    'click .js-upgrade': (e) ->
      track("Board Menu", "Collections Menu", "Upgrade Button")

  viewTitleKey: 'pick tags'

  addTag: (e) ->
    Util.stop(e)
    track('Board Menu', 'Collections Menu', 'Open Create Tag Menu')
    PopOver.toggle
      elem: e.target
      view: AddTagView
      options:
        model: @organization
        modelCache: @modelCache
        boardView: true

  toggleTag: (idTag) ->
    @model.toggleTag(idTag)

  filterTagsBySearch: (tags) ->
    searchVal = @_searchVal().toLowerCase()
    if _.isEmpty(searchVal)
      return tags

    _.filter(tags, (tag) -> tag.get('name')?.toLowerCase().indexOf(searchVal) > -1)

  filterTagsByAssociation: (tags, boardTags) ->
    _.groupBy(tags, (tag) => if tag.id in boardTags then 'associated' else 'notAssociated')

  _searchVal: ->
    @$('.js-collections-search').val()?.trim() ? ""

  renderFilteredCollections: ->
    if !@organization?.tagList.models.length
      return

    filteredTags = @filterTagsByAssociation(@filterTagsBySearch(@organization.tagList.models), @model.getIdTags())
    @$('.js-filtered-collections')
      .empty()
      .append(collectionsList(filteredTags))

  refereshOrganization: ->
    oldOrganization = @modelCache.get('Organization', @model.previous('idOrganization'))
    organization = @model.getOrganization()

    if oldOrganization?
      @stopListening oldOrganization.tagList

    @organization = organization
    @collectionsEnabled = @organization? && @organization.isFeatureEnabled('tags')

    if @collectionsEnabled
      @listenTo @organization.tagList, 'add remove reset change', @render

    @render()

  render: ->
    me = Auth.me()
    hideExplainer = me.isDismissed("CollectionsExplainer")

    hasTags = @organization?.tagList.models.length

    if @organization
      orgUrl = Controller.getOrganizationUrl(@organization)
      billingUrl = Controller.getOrganizationBillingUrl(@organization)

    @$el.html template({
      board: @model
      collectionsEnabled: @collectionsEnabled
      billingUrl: billingUrl
      orgUrl: orgUrl
      hasTags: hasTags
      hideExplainer: hideExplainer
    })

    @renderFilteredCollections()

    @
